module.exports = __webpack_public_path__ + "static/media/9DESA2.cd8511b5.jpg";